function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_29",
  "data-name": "Group 29",
  transform: "translate(187.736 300.201) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(3.848)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(171.514 293.826)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x2: 12,
  y2: 0.001,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_337",
  "data-name": "Group 337",
  transform: "translate(475.188 116.313) rotate(90)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_27-2",
  "data-name": "Group 27",
  transform: "translate(171.514 293.826)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10-2",
  "data-name": "Line 10",
  x2: 12,
  y2: 0.001,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75
}))));

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.75,
    height: 12.75,
    viewBox: "0 0 12.75 12.75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.049f2057.svg";
export { ForwardRef as ReactComponent };